import script from "./Limits.vue?vue&type=script&setup=true&lang=js"
export * from "./Limits.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__